module.exports = {
	'customFolder.m4.m410130_grid': {
		'courseName': '課程名稱',
		'courseClassification': '課程分類',
		'modeOfDelivery': '上課方式',
		'typeOfTraining': '訓練種類',
		'classTime': '上課時間',
		'courseHours': '課程時數',
		'learningStatus': '學習狀態',
	},
	'customFolder.m4.m410130': {
		'manifestMode': '清單模式',
		'chartMode': '圖表模式',
	},
	'customFolder.m4.m410130_chart': {
		'anOverviewOfLearningRecords': '學習紀錄總覽',
		'hours': '時數',
		'hall': '堂',
		'totalPeople': '共 <%=temp1%> 人',
		'noData': '無資料',
	},
	'customFolder.m4.m410130_browse': {
		'courseRequirements': '課程需求',
		'organizers': '主辦單位',
		'instructorSName': '講師姓名',
		'trainingLocation': '訓練地點',
		'credit': '學分',
		'quizScores': '測驗分數',
		'quizResults': '測驗結果',
		'reasonForNonConformity': '不合格原因',
		'costSharingCorporate': '費用分擔(公司)',
		'costSharingEmployees': '費用分擔(員工)',
		'theDurationOfTheContractFor': '工作簽約期限',
		'theExpirationDateOfTheJob': '工作簽約到期日',
		'tempYears': '<%=temp1%> 年',
		'tempMonth': ' <%=temp1%> 月',
		'tempYearsAndMonths': '<%=temp1%> 年 <%=temp2%> 月',
		'hour': '小時',
		'credits': '學分',
		'divide': '分',
	},
	'customFolder.service.m3.service-m310240': {
		'aBreakdownOfTheDepartmentS': '部屬學習紀錄明細表',
	},
};
